import {AttributeChangeRequest} from 'src/openapi/models/AttributeChangeRequest';

export const getAttributeIds = (
    attributes: Array<AttributeChangeRequest>,
): Array<number> => {
    return attributes.map(attribute => Number(attribute.id));
};
